import { render } from "./PersonalProfile.vue?vue&type=template&id=5ba636fd&ts=true"
import script from "./PersonalProfile.ts?vue&type=script&lang=ts&external"
export * from "./PersonalProfile.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__